import { NoDataEnDash } from '@packages/components/no-data-en-dash/no-data-en-dash';
import { Stack, Typography } from '@packages/fenrir/components';

type RowExpansionItemProps = React.PropsWithChildren<{ title: string }>;

export const RowExpansionItem: React.FC<RowExpansionItemProps> = ({
  title,
  children,
}) => {
  return (
    <Stack
      spacing={2}
      direction="row"
      sx={{
        mb: 1.5,
        alignItems: 'flex-start',
      }}
    >
      <Typography variant="h5">{title}</Typography>
      {children || <NoDataEnDash />}
    </Stack>
  );
};
